import accountSettingsModule from '../accountSettingsModule';

function userAccountBase(accountConstantsResources) {
  'ngInject';

  return {
    restrict: 'A',
    scope: true,
    templateUrl: accountConstantsResources.templates.userAccountBase
  };
}

accountSettingsModule.directive('userAccountBase', userAccountBase);

export default userAccountBase;
